import {actionTypes} from "../storeConstants";

export const updateLanguageAction = (language) => {
    return ({
        type: actionTypes.UPDATE_LANGUAGE,
        payload: language
    });
}